import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import {
  MainDashboardPage,
  OverlayLoader,
  EmptyScreen,
  Button,
} from 'components';
import { Trans, useTranslation } from 'react-i18next';
import { useCurrentOrganizationId, useOrganizationSessions } from 'queries';
import { Navigate } from 'react-router-dom';

const useStyles = createUseStyles((theme: Theme) => ({
  textContainer: {
    marginBottom: theme.marginBase * 4,
    marginTop: theme.marginBase * 4,
  },
  text: {
    ...theme.fonts.body,
    color: theme.colors.inkSecondary,
    maxWidth: theme.maxContentWidth.reduced,
    marginBottom: theme.marginBase * 2,
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.marginBase,
  },
}));

export const Welcome = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  const orgId = useCurrentOrganizationId();
  const { data, isLoading: fetchingSessions } = useOrganizationSessions(orgId);

  const sessionCount =
    data && data.pages.length && data.pages[0].pagination.count;

  if (sessionCount) {
    return <Navigate to="/" />;
  }

  if (fetchingSessions) {
    return (
      <MainDashboardPage>
        <OverlayLoader />
      </MainDashboardPage>
    );
  }

  return (
    <AnalyticsCategoryProvider category={Categories.GENERAL}>
      <MainDashboardPage>
        <EmptyScreen title={t('intro.title')}>
          <div className={classes.textContainer}>
            <Trans
              i18nKey="intro.subtitle"
              components={{
                p: <p className={classes.text} />,
              }}
            />
          </div>
          <div className={classes.buttons}>
            <Button
              href="https://www.bilendi-ux.com"
              target="_blank"
              rel="noreferrer"
              text={t('intro.learnMore')}
              color="accent"
              variant="transparent"
            />
            <Button
              to="/sessions/create"
              text={t('intro.sessionButton')}
              color="accent"
            />
          </div>
        </EmptyScreen>
      </MainDashboardPage>
    </AnalyticsCategoryProvider>
  );
};
